export default "__VITE_ASSET__BiL_NTEH__"